module.exports = __webpack_public_path__ + "static/media/img6.d8f780bf.jpg";